import { HttpClient } from "@angular/common/http";
import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { DialogService } from "src/app/utils/dialog.service";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import Swal from "sweetalert2";
import { AddPrelungireComponent } from "../../add-prelungire/add-prelungire.component";
import { IstoricRegistruComponent } from "../../istoric-registru/istoric-registru.component";
import { RegistruService } from "../../registru.service";
import { IFieldProps } from "../../registru.interface";
import { EditFieldComponent } from "../../edit-field/edit-field.component";

@Component({
    selector: "app-autorizatie-alimentatie-publica",
    templateUrl: "./autorizatie-alimentatie-publica.component.html",
    styleUrls: ["./autorizatie-alimentatie-publica.component.scss"],
})
export class AutorizatieAlimentatiePublicaComponent
    implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @Input() dataTableParams: any;
    @Input() registru_id!: number;
    @Output() dataTableParametersChange = new EventEmitter<any>();
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    isLoading = false;

    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru.listDT;

    constructor(
        private http: HttpClient,
        private dialogService: DialogService,
        private dialog: MatDialog,
        private registruService: RegistruService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }
    ngAfterViewInit(): void {
        this.dtTrigger.next("");
    }
    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[2, "desc"]],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.type = this.registru_id;

                if (this.dataTableParams) {
                    dataTablesParameters.filters = this.dataTableParams.filters;
                    dataTablesParameters.tip_date = this.dataTableParams.tip_date;
                    dataTablesParameters.date_from = this.dataTableParams.date_from;
                    dataTablesParameters.date_to = this.dataTableParams.date_to;
                }

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.dataTableParametersChange.emit(dataTablesParameters);
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: "Nr crt",
                    orderable: false,
                    data: "no_crt",
                    render: (data: any, type: any, row: any) => {
                        return `
                        <span>${row.no_crt}</span>
                        `;
                    },
                },
                {
                    title: "Tip Doc",
                    orderable: false,
                    data: "type_name",
                },
                {
                    title: "Nr Autorizație",
                    orderable: false,
                    data: "document_numar",
                },
                {
                    title: "Data eliberării",
                    orderable: false,
                    data: "document_data",
                },
                {
                    title: "Nr/Dată Cerere",
                    orderable: false,
                    data: "cerere_details",
                },
                {
                    title: "Punct lucru/Nume comerciant",
                    orderable: false,
                    data: null,
                    className: "all",
                    render: (data: any, type: any, row: any) => {
                        return `
                                <div style="display: flex; justify-content: space-between; gap: 5px">
                                    <div style="width:200px" >
                                        <span>${row.punct_lucru}</span>
                                        <hr>
                                        <span>${row.f_nume ? row.f_nume : "N/A"}</span>
                                    </div>
                                    <button style="height: 24px" class="action-btn edit punct_lucru" title="Editează">
								        <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
							        </button>
                                </div>
                            `;
                    },
                },
                {
                    title: "CUI",
                    orderable: false,
                    data: "f_cui",
                },
                {
                    title: "Denumire Agent Economic/Sediu",
                    orderable: false,
                    data: "sediu",
                    className: "all",
                    render: (data: any, type: any, row: any) => {
                        return `
                                <div style="display: flex; justify-content: space-between; gap: 5px">
                                    <div style="width:200px" >
                                        <span>${row.f_nume ? row.f_nume : "N/A"}</span>
                                        <hr>
                                        <span>${row.sediu}</span>
                                    </div>
                                    <button style="height: 24px" class="action-btn edit sediu" title="Editează">
								        <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
							        </button>
                                </div>
                            `;
                    },
                },
                {
                    title: "CAEN",
                    orderable: false,
                    data: "obiect_activitate",
                    className: "all",
                    render: (data: any, type: any, row: any) => {
                        return `
                            <div style="display: flex; justify-content: space-between; gap: 5px">
                                <span>${row.obiect_activitate}</span>
						        <button style="height: 24px" class="action-btn edit obiect_activitate" title="Editează">
								    <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
							    </button>
                            </div>
                        `;
                    },
                },
                {
                    title: "Valabilitate",
                    orderable: false,
                    data: "valability",
                    className: "all",
                    render: (data: any, type: any, row: any) => {
                        return `
                            <div style="display: flex; justify-content: space-between; gap: 5px">
                                <span>${row.valability}</span>
						        <button style="height: 24px" class="action-btn edit valability" title="Editează">
								    <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
							    </button>
                            </div>
                        `;
                    },
                },
                {
                    title: "Prelungiri(vize)",
                    orderable: false,
                    data: "prelungiri",
                    className: "all",
                    render: (data: any, type: any, row: any) => {
                        return `
                            <button class="action-btn addPrelungire" title="Adaugă">
                            <i class="fa-solid fa-plus"></i>
                            </button>
                        `;
                    },
                },
                {
                    title: "#",
                    orderable: false,
                    data: null,
                    className: "all",
                    render: (data: any, type: any, row: any) => {
                        return `
                            <div class="d-flex d-flex align-center justify-content-left gap-1">
                                <span title="Istoric" class="history">
                                    ${row.actions}
                                </span>
                                <button title="Updatează Status" type="button" class="action-btn update_status_public ` +
                            (row.public_view == true
                                ? "action-success"
                                : "action-danger") +
                            `">
                                    <img class="btn-img" src="` +
                            (row.public_view == true
                                ? "/assets/icons/public_white.svg"
                                : "/assets/icons/public_not_white.svg") +
                            `" alt="update_status_public"/>
                                </button>
                            </div>
						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const updatePunctLucru = (row as HTMLElement).querySelector(
                    ".punct_lucru"
                ) as HTMLElement;
                const updateSediu = (row as HTMLElement).querySelector(
                    ".sediu"
                ) as HTMLElement;
                const updateCAEN = (row as HTMLElement).querySelector(
                    ".obiect_activitate"
                ) as HTMLElement;
                const updateValability = (row as HTMLElement).querySelector(
                    ".valability"
                ) as HTMLElement;
                const addIcon = (row as HTMLElement).querySelector(
                    ".addPrelungire"
                ) as HTMLElement;
                const historyButton = (row as HTMLElement).querySelector(
                    ".history"
                ) as HTMLElement;
                const updateStatusPublicIcon = (row as HTMLElement).querySelector(
                    ".update_status_public"
                ) as HTMLElement;

                if (updatePunctLucru) {
                    updatePunctLucru.addEventListener("click", () => {
                        const { id, punct_lucru } = data;
                        const field: IFieldProps = {
                            fieldData: punct_lucru,
                            fieldParam: 'punct_lucru',
                            fieldName: 'Punct de lucru',
                        }
                        this.editField(id, field);
                    });
                }
                if (updateSediu) {
                    updateSediu.addEventListener("click", () => {
                        const { id, sediu } = data;
                        const field: IFieldProps = {
                            fieldData: sediu,
                            fieldParam: 'sediu',
                            fieldName: 'Sediu social',
                        }
                        this.editField(id, field);
                    });
                }
                if (updateCAEN) {
                    updateCAEN.addEventListener("click", () => {
                        const { id, obiect_activitate } = data;
                        const field: IFieldProps = {
                            fieldData: obiect_activitate,
                            fieldParam: 'obiect_activitate',
                            fieldName: 'CAEN',
                        }
                        this.editField(id, field);
                    });
                }
                if (updateValability) {
                    updateValability.addEventListener("click", () => {
                        const { id, valability } = data;
                        const field: IFieldProps = {
                            fieldData: valability,
                            fieldParam: 'valability',
                            fieldName: 'Valabilitate',
                        }
                        this.editField(id, field);
                    });
                }

                if (addIcon) {
                    // if (
                    //   !this.permissionsService.hasPermission(
                    //     'autcom-module.settings.registre.add'
                    //   )
                    // ) {
                    //   addIcon.style.display = 'none';
                    // }

                    addIcon.addEventListener("click", () => {
                        const { id } = data;
                        this.addPrelungiri(data);
                    });
                }

                if (historyButton) {
                    historyButton.addEventListener("click", () => {
                        const { id } = data;
                        this.history(id);
                    });
                }

                if (updateStatusPublicIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'autcom-module.settings.registre.update-status'
                    //     )
                    // ) {
                    //     updateStatusPublicIcon.style.display = 'none';
                    // }

                    updateStatusPublicIcon.addEventListener("click", () => {
                        const { id } = data;
                        this.changeStatusPublic(id);
                    });
                }
            },
        };
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }

    editField(id: number, field: IFieldProps) {
        const dialogRef = this.dialog.open(EditFieldComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                id,
                field
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }

    history(data: any) {
        console.log("test", data);
        const dialogRef = this.dialog.open(IstoricRegistruComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();

            }
        });
    }

    addPrelungiri(data: any) {
        console.log("test", data);
        const dialogRef = this.dialog.open(AddPrelungireComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                ...data,
                type_id: this.registru_id
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Prelungire actualizată cu succes!",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    changeStatusPublic(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să actualizați statusul înregistrării selectate!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusPublicAction(id);
            }
        });
    }

    changeStatusPublicAction(id: number) {
        this.isLoading = true;
        this.registruService.changeStatusPublic(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Înregistrare actualizată cu succes!",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: "error",
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusPublicAction(id);
                    }
                });
            }
        );
    }
}
